<template>
    <div>
        <v-alert
            v-if="tenant[0]?.payment_method == 'Boleto Asaas' && !this.$vuetify.breakpoint.smAndDown"
            text
            dense
            color="warning"          
            class="mt-3 pa-4"
        >
                <div class="black--text" v-if="!this.$vuetify.breakpoint.smAndDown">
                    <div class="black--text">
                        Ao clicar no botão <span class="font-weight-bold">BAIXAR BOLETO</span>, você poderá realizar o pagamento via <span class="font-weight-bold"> QR Code Pix</span> ou código de barras.
                    </div>
                </div>
        </v-alert>
        
        <v-row v-if="object.data && object.data.length > 0" class="mt-3">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"> 
                <span v-if="!this.$vuetify.breakpoint.smAndDown">
                    <span class="text-subtitle-1 font-weight-bold text-truncate">Histórico de mensalidades</span> 
                    <span>(12 últimas)</span>
                </span>

                <span v-else>
                    <span class="text-subtitle-1 font-weight-bold text-truncate">Últimas mensalidades</span> 
                </span>


                <v-card
                    v-if="!this.$vuetify.breakpoint.smAndDown"
                    class="mx-auto"
                    outlined
                >
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">
                                    FATURA
                                </th>
                                <th class="text-left">
                                    STATUS
                                </th>
                                 <th class="text-left">
                                    VALOR R$
                                </th>
                                <th class="text-left">
                                    DT VENC.
                                </th>
                                <th class="text-left">
                                    DT PGTO.
                                </th>
                                <th class="text-left">
                                    AÇÕES
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="itm in object.data"
                                    :key="itm.id"
                                >
                                <td>
                                    <v-chip
                                        label
                                        small
                                        class="overline"
                                    >
                                        {{ itm.codigo }}
                                    </v-chip>
                                </td>
                                <td>
                                    <v-chip
                                        :color="statusDueDate(itm).color"
                                        label
                                        small
                                        class="overline"
                                    >
                                        {{ statusDueDate(itm).description }}
                                    </v-chip>
                                </td>
                                <td>
                                    <span class="overline">R$ {{ setTotal(itm.json_account_values) }}</span>
                                    <v-menu
                                        open-on-click
                                        top
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon  
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-1"
                                                color="red"
                                            >
                                                mdi-information-variant-circle-outline
                                            </v-icon>
                                        </template>
                
                                        <v-simple-table>
                                            <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        DESCRIÇÃO
                                                    </th>
                                                    <th class="text-left">
                                                        R$
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="it in itm.json_account_values" :key="it.id">
                                                    <td>{{ it.description }}</td>
                                                    <td>R$ {{ it.value }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" class="text-center font-weight-bold">{{ itm.nome }}</td>
                                                </tr>
                                            </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-menu>
                                </td>
                                <td class="overline">{{ formatDate(itm.due_date) }}</td>
                                <td class="overline">{{ formatDate(itm.payment_date) }}</td>
                                <td>
                                    <span v-if="itm.bank_slips && itm.bank_slips.length > 0">

                                        <v-btn  
                                            v-if="itm.bank_slips[0].pix && itm.bank_slips[0].pix != ''"
                                            class="mr-4"
                                            dark
                                            color="purple"
                                            outlined
                                            @click="dialogPix(itm.bank_slips[0])"       
                                        >
                                            <v-icon large>$pix</v-icon>
                                            Copiar
                                        </v-btn>


                                        <v-btn  
                                            v-if="itm.bank_slips[0].pix && itm.bank_slips[0].pix != '' && itm.bank_slips[0].linhaDigitavel != ''"
                                            class="mr-4"
                                            dark
                                            color="purple"
                                            outlined
                                            @click="copyLink(itm.bank_slips[0].linhaDigitavel, 'Código barras copiado')"       
                                        >
                                            <v-icon class="mr-1">mdi-barcode-scan</v-icon>
                                            Copiar
                                        </v-btn>  

                                        <v-btn
                                            dark
                                            color="green"
                                            :class="$css_button"
                                            target="blank"
                                            :href="itm.bank_slips[0].linkBoleto"
                                            outlined
                                        >
                                            Baixar boleto
                                        </v-btn>
                                    </span>

                                    <span v-else>
                                        <v-btn
                                            v-if="itm.payment_date == null"
                                            dark
                                            color="purple"
                                            :class="$css_button"
                                            outlined
                                            @click="storeBankSlip(itm.id)"
                                        >
                                            Gerar boleto
                                        </v-btn>
                                    </span>
                                </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>  
                
                <div v-else >
                    <MobileAccountCard
                        v-for="item in limitedAccounts"
                        :key="item.id"
                        :item="item"
                        @callCopyLink="copyLink"
                        @callDialogPix="dialogPix"
                        @callStoreBankSlip="storeBankSlip"
                    />
                </div>    
            </v-col>
        </v-row>  

        <v-dialog
            v-model="dialog.bank_slip_delay"
            transition="dialog-bottom-transition"
            max-width="600"
        >
                <v-card>
                    <v-toolbar
                        color="primary"
                        dark
                    >   
                        Instrução de pagamento
                    </v-toolbar>
                    <v-card-text>
                        <div class="pa-2 mt-4" v-if="tenant[0] && tenant[0].payment_method && tenant[0]?.payment_method == 'Boleto Asaas'">
                           <div class="mt-2 black--text">
                                <div class="black--text mt-3">
                                    Ao clicar no botão <span class="font-weight-bold">BAIXAR BOLETO</span>, você poderá realizar o pagamento via <span class="font-weight-bold"> QR Code Pix</span> ou código de barras.
                                </div>
                           </div>
                        </div>
                        <div v-else class="text-h4 pa-12">
                            Aguarde até 2 horas para pagar esse titulo.
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                    <v-btn
                        text
                        @click="dialog.bank_slip_delay = false"
                    >Fechar</v-btn>
                    </v-card-actions>
                </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog.pix"
            transition="dialog-bottom-transition"
            max-width="400"
        >
            <v-card class="pa-6">
                <v-img
                    v-if="pixQrCodeSrc"
                    :src="pixQrCodeSrc"
                    alt="QR Code Pix"
                    max-width="300"
                    class="mx-auto"
                ></v-img>

                <v-text-field
                    v-model="pix.pix"
                    label="Código Pix"
                    readonly
                    outlined
                    hide-details
                    class="mt-4"
                    append-icon="mdi-content-copy"
                    @click:append="copyLink(pix.pix, 'Código Pix copiado')"
                ></v-text-field>
            </v-card>            
        </v-dialog>

    </div>
</template>

<script>
import MobileAccountCard from './MobileAccountCard.vue';

export default {
    components: {
        MobileAccountCard,
    },  
    
    props: {
        object: {
            require: true,
        },
    },

    computed: {
        tenant() {
            return this.$store.state.tenants.items.data    
        },

        me () {
          return this.$store.state.auth.me
        },

        limitedAccounts() {
        // Verificamos se o objeto e os dados existem antes de dar o slice
            return this.object?.data ? this.object.data.slice(0, 3) : [];
        },

        pixQrCodeSrc() {
            if (this.pix && this.pix.encodedImage) {
            // Verifica se a string já não contém o prefixo para não duplicar
            if (this.pix.encodedImage.startsWith('data:image')) {
                return this.pix.encodedImage;
            }
            return `data:image/png;base64,${this.pix.encodedImage}`;
            }
            return null;
        }
    },

    data () {
        return {
            dialog: {
                bank_slip_delay: false,
                pix: false,
            },

            pix:{},

            headers: [
                { text: 'CODIGO', align: 'start', value: 'codigo', },
                { text: 'VALOR', align: 'start', value: 'valor' },
                { text: 'STATUS', align: 'start', value: 'status' },  
                { text: 'DATA VENCIMENTO', align: 'start', value: 'due_date' },
                { text: 'DATA PAGAMENTO', align: 'start', value: 'payment_date' }            
            ],
        }
    },

    methods:{   
        setTotal(json){
            let total = 0
            if(json && json.length > 0){
                json.forEach(model => {
                    if(model.type == 'Crédito'){
                        total += model.value 
                    }
                })
            }
            return total
        },

        storeBankSlip(id){
            const data = {}
            data.id = id

            this.$store.dispatch('storeBankSlip', data)
                    .then(response => {
                        const bankslip = response.data   
                        if(this.tenant[0] && this.tenant[0].payment_method && this.tenant[0].payment_method != 'Boleto Cora'){
                            this.dialog.bank_slip_delay = true
                        }
                        this.$snotify.success('Boleto gerado com sucesso!')
                        this.$emit('callLoadAccounts')
                    })
                    .catch(error => {
                        console.log(error)
                        this.$snotify.error('Erro no cadastro')
                    }); 
        },

        copyLink(item, msg){
            if(!item) return
            if(!msg) return
            navigator.clipboard.writeText(item);
            this.$snotify.success(msg, 'Sucesso')
        },

        dialogPix(item){
            this.dialog.pix = !this.dialog.pix
            this.pix = {};
            if(this.dialog.pix == true){
                this.pix = item
            }    
        },
    }    
}
</script>